import { render, staticRenderFns } from "./chartSalesArea.vue?vue&type=template&id=1f473f24&"
import script from "./chartSalesArea.vue?vue&type=script&lang=js&"
export * from "./chartSalesArea.vue?vue&type=script&lang=js&"
import style0 from "./chartSalesArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports